import { can, type Role } from "@ide/shared";

/**
 * A IA (Claude, Copilot, agente) vale para todo membro do projeto, menos visualizadores — sem o
 * dono precisar ligar. Servidores antigos não mandam `permissions.ai`: a tabela de papéis decide.
 */
export function aiAllowed(detail: { role: Role; permissions: { ai?: boolean } }): boolean {
  return detail.permissions.ai ?? can(detail.role, "ai");
}
